{
  "forms": {
    "function_label": "Function",
    "period_label": "Period",
    "name_label": "Name",
    "prompt_label": "Prompt",
    "files_label": "Files",
    "view_label": "View",
    "device_function_label": "Device or Function",
    "operator_label": "Operator"
  },
  "errors": {
    "unexpected_error": "Sorry, unexpected error occured, please try again or contact Support"
  },
  "modals": {
    "share_dashboard": "Share Dashboard",
    "edit_dashboard": "Edit Dashboard",
    "confirmation": "Are you sure?",
    "delete_confirmation": "Are you sure you want to delete this? You can't undo this action"
  },
  "sections": {
    "settings": "Settings",
    "basic_info": "Info",
    "alert_info": "Alert Info",
    "subscribers": "Subscribers",
    "time_period": "Time Range & Schedule",
    "content_settings": "Content"
  },
  "tooltips": {
    "actions": "Actions",
    "toggle_parameters": "Toggle Parameters",
    "resize_widget": "Resize Widget",
    "move_widget": "Move Widget",
    "remove_condition": "Remove Condition",
    "see_standard_details": "Learn about this standard",
    "see_aggregation_details": "See how aggregation works",
    "notification_methods": "When choosing SMS or Email & SMS every user should have a valid phone number in their profile",
    "usb_battery": "USB Battery Source"
  },
  "base": {
    "pagination": {
      "first_page": "First Page",
      "last_page": "Last Page",
      "prev_page": "Previous Page",
      "next_page": "Next Page"
    },
    "buttons": {
      "close": "Close",
      "undo": "Undo",
      "cancel": "Cancel",
      "apply": "Apply",
      "apply_changes": "Apply Changes",
      "add_new": "Add New",
      "add": "Add",
      "edit": "Edit",
      "accept": "Accept",
      "reject": "Reject",
      "decline": "Decline",
      "remove": "Remove",
      "reveal": "Reveal",
      "older": "Older",
      "newer": "Newer",
      "delete": "Delete",
      "remind": "Remind",
      "admin": "Admin",
      "view": "View",
      "clone": "Clone",
      "duplicate": "Duplicate",
      "preview": "Preview",
      "download": "Download",
      "download_pdf": "Download PDF",
      "pdf": "PDF",
      "submit": "Submit",
      "sign_up": "sign up",
      "create_new": "Create New",
      "lock": "Lock",
      "unlock": "Unlock",
      "save_changes": "Save Changes",
      "change": "Change",
      "save": "Save",
      "transfer": "Transfer",
      "update": "Update",
      "invite": "Invite",
      "create": "Create",
      "revoke": "Revoke",
      "share": "Share",
      "configure": "Configure",
      "configuration": "Configuration",
      "rollout": "Rollout",
      "reset_access": "Back to Your Account",
      "run": "Run",
      "send": "Send",
      "manage": "Manage",
      "continue_save": "Ok",
      "reset": "Reset",
      "copy_link": "Copy Link",
      "design_access_context": "Design Access Context",
      "design_access_back": "Back to Your Account",
      "pause_live_updates": "Pause Live Updates",
      "resume_live_updates": "Resume Live Updates",
      "refresh_page": "Refresh Page",
      "refresh": "Refresh",
      "alert": "Alert",
      "group_alert": "Group Alert",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "monitor": "Monitor"
    },
    "labels": {
      "all": "All",
      "value": "Value",
      "settings": "Settings",
      "select": "Select",
      "with": "With",
      "from": "From",
      "locked": "Locked",
      "to": "To",
      "actions": "Actions",
      "loading": "loading...",
      "show_all": "Show All",
      "show_more": "Show More",
      "more": "more",
      "less": "less",
      "no_records": "No records found",
      "no_data": "No Data",
      "no_data_available": "No Data Available",
      "sent_invitations": "Sent Invitations",
      "list_view": "List View",
      "grid_view": "Grid View",
      "reload_data": "Reload Data",
      "select_date": "Select Date",
      "select_all": "Select All",
      "select_none": "Select None",
      "abs": "Abs",
      "abs_short": "Abs",
      "min": "Minimum",
      "min_short": "Min",
      "avg": "Average",
      "avg_short": "Avg",
      "max": "Maximum",
      "max_short": "Max",
      "warning": "Warning",
      "n_a": "N/A",
      "switched_on": "On",
      "switched_off": "Off",
      "visible": "Visible",
      "hidden": "Hidden",
      "none": "None",
      "remove_all": "Remove All",
      "auto": "Auto",
      "manual": "Manual",
      "or": "OR",
      "yes": "Yes",
      "no": "No",
      "copy_to_clipboard": "Copy to clipboard",
      "copy_link": "Copy URL",
      "select_entity": "Select entity",
      "copied": "Copied!",
      "choose": "Choose",
      "search_add_new": "Search or add new...",
      "disabled": "Disabled",
      "off": "Off",
      "brand": "Brand:",
      "weekly": "Weekly",
      "daily": "Daily",
      "select_deselect_all": "Select / Deselect All"
    },
    "days": {
      "sunday": "Sunday",
      "sunday_short": "Sun",
      "monday": "Monday",
      "monday_short": "Mon",
      "tuesday": "Tuesday",
      "tuesday_short": "Tue",
      "wednesday": "Wednesday",
      "wednesday_short": "Wed",
      "thursday": "Thursday",
      "thursday_short": "Thu",
      "friday": "Friday",
      "friday_short": "Fri",
      "saturday": "Saturday",
      "saturday_short": "Sat"
    }
  },
  "hints": {
    "loadingWifiList": "Loading may take up to 1 minute"
  },
  "us_states": {
    "select_state": "Select a state"
  },
  "select_countries": "Select a country",
  "datepicker": {
    "select_date": "Select Date...",
    "custom_range": "Custom Range",
    "apply_label": "Apply",
    "cancel": "Cancel",
    "unpin_time_selection": "Unpin time selection",
    "keep_time_range": "Keep time range",
    "ranges": {
      "live": "Live",
      "today": "Today",
      "yesterday": "Yesterday",
      "this_week": "This Week",
      "last_week": "Past Week",
      "this_month": "This Month",
      "last_month": "Past Month"
    }
  },
  "sings": {
    "multiplication": "\u2715",
    "equal": "\u003D",
    "plus": "\u002B",
    "minus": "\u2212"
  },
  "time": {
    "never": "Never",
    "one_sec": "1 second",
    "number_secs": "%{n} seconds",
    "number_secs_short": "%{n} secs",
    "one_min": "1 minute",
    "number_mins": "%{n} minutes",
    "number_mins_short": "%{n}mins",
    "one_hour": "1 hour",
    "number_hours": "%{n} hours",
    "number_hours_short": "%{n}hr",
    "one_day": "1 day",
    "number_days": "%{n} days",
    "number_days_short": "%{n}d",
    "one_week": "1 week",
    "number_weeks": "%{n} weeks",
    "number_weeks_short": "%{n}w",
    "one_month": "1 month",
    "number_months": "%{n} months",
    "one_year": "1 year",
    "number_years": "%{n} years",
    "last_duration": "Last %{duration}"
  },
  "dialogs": {
    "titles": {
      "auth_issue": "Authorization Issue"
    },
    "token_expired": {
      "btn": "Go to Login Page",
      "msg": "Your account can not be authorized. Please try to login again."
    }
  },
  "notifications": {
    "empty": "There are no notifications"
  },
  "addresses": {
    "billing": {
      "section_title": "Billing Address"
    },
    "shipping": {
      "section_title": "Shipping Address"
    }
  },
  "contact_infos": {
    "section_title": "Contact Info"
  },
  "invitation_states": {
    "filed": "Pending",
    "accepted": "Accepted",
    "rejected": "Rejected"
  },
  "produced_by": "Produced By",
  "locale_name": "English",
  "theme": {
    "light": "Light Theme",
    "dark": "Dark Theme"
  },
  "groups": {
    "functions": "Functions",
    "devices": "Devices"
  },
  "operators": {
    "greater_or_equal": "Greater or equal"
  },
  "admin_actions": {
    "reboot": "Reboot",
    "format": "Format",
    "sim_reset": "SIM Reset"
  },
  "placeholders": {
    "choose_action": "Choose action..."
  },
  "units": {
    "auto": "Auto",
    "mg": "mg",
    "ug": "μg"
  },
  "percentages": {
    "off": "Off",
    "25_percent": "25%",
    "50_percent": "50%",
    "75_percent": "75%",
    "100_percent": "100%"
  },
  "view_types": {
    "basic": "Basic",
    "extended": "Extended"
  },
  "grid": {
    "columns": {
      "name": "Name",
      "message": "Message",
      "last_triggered": "Last Triggered",
      "status": "Status",
      "condition": "Condition",
      "email": "Email",
      "user_role": "User Role",
      "organization": "Organization",
      "created": "Created",
      "organization_name": "Organization",
      "partner_name": "Partner",
      "date_created": "Date Created",
      "address": "Address",
      "type": "Type",
      "from": "From",
      "to": "To",
      "url": "URL",
      "enabled": "Enabled",
      "last_updated": "Last Updated",
      "result": "Result",
      "created_at": "Created At",
      "timestamp": "Timestamp",
      "tag": "Tag",
      "parameter": "Parameter",
      "value": "Value"
    }
  }
}